export const name = 'getCurrentTime';
export const description = 'Returns the current local time of the user.';
export const parameters = {};
export const outputTextForUI = "Jelenlegi idő lekérése";
export const useOnMobile = true;

export function getCurrentTime() {
  const now = new Date();
  return {
    time: now.toLocaleString('hu-HU'),
    city: 'Helyi idő'
  };
}
